@for (item of actionItems; track item) {
  <button
    mat-menu-item
    type="button"
    [attr.aria-label]="item.label"
    (click)="handleFullRecordAction(item.action)"
  >
    {{ item.label }}
  </button>
}
